module["exports"] = [  
  "##",
  "#"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/address/building_number.js
// module id = 2382
// module chunks = 2